module.exports = __webpack_public_path__ + "fc20db9792094f3be6c0c2ba69025532.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/hotline_footer.png
// module id = ./app/images/hotline_footer.png
// module chunks = 40